import {
  shape,
  string,
  object,
  arrayOf,
} from 'prop-types';

const shipmentStopShape = shape({
  address: object,
  locationNumber: string,
  contactName: string,
  contactPhoneNumber: string,
  appointmentStart: string,
  appointmentEnd: string,
  actualCheckIn: string,
  actualCheckOut: string,
  locationAccessorials: arrayOf(string),
  notes: string,
});

export default shipmentStopShape;
